import { fetchy } from '@bridebook/web/lib/fetchy';
import type { IUISupplier, TrackEventBody, TrackEventBodyWeb } from '@bridebook/toolbox/src/types';
import type { IApplicationState } from '@bridebook/web/lib/types';
import getServerSideAnalyticsProps from '@bridebook/web/lib/utils/get-server-side-analytics-props';

export interface IServerSideTrack extends TrackEventBody {
  state: IApplicationState;
  event: string;
  identifyProps?: Record<string, any>;
  specificEventProps?: Record<string, any>;
  contactedSupplier?: IUISupplier;
  bookedSupplier?: IUISupplier;
  category?: string;
}

const serverSideTrack = ({
  state,
  event,
  identifyProps,
  specificEventProps,
  contactedSupplier,
  bookedSupplier,
  category = '',
}: IServerSideTrack) => {
  const body: TrackEventBodyWeb = {
    event,
    identifyProps,
    genericProps: getServerSideAnalyticsProps(state),
    specificEventProps,
    source: 'web',
    contactedSupplier,
    bookedSupplier,
    category,
  };

  return fetchy().post('/api/a/t', null, body);
};

export default serverSideTrack;
